/**
 * Страны ISO-3166-1. Источник — core (его копия файла стран TH, reference/country-reference.json) через публичный /api/v1/reference/countries.
 * Кэш на модуль — список статичный, тянем один раз.
 */
import { http } from './http';

export interface Country {
  name: string;
  alpha2: string;
  alpha3: string;
}

let cache: Country[] | null = null;
let inflight: Promise<Country[]> | null = null;

export async function loadCountries(): Promise<Country[]> {
  if (cache) return cache;
  if (!inflight) {
    inflight = http.get<Country[]>('/v1/reference/countries')
      .then(r => { cache = r.data; return cache; })
      .finally(() => { inflight = null; });
  }
  return inflight;
}
